import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { get } from "lodash";

import mediator from "@tvg/mediator";
import {
  DerbyEventStatus,
  BannerContext,
  HeaderBanner
} from "@urp/derby-banner/src/types";
import { getEventType } from "@urp/derby-banner/src/utils";
import buildRaceUrl from "@tvg/formatter/url";
import {
  getDerbyRace,
  getEventDate,
  getTodayDate,
  getHomepageDerbyBanner,
  getHomepageEventTrackAbbr,
  getHomepageCurrentConfig,
  getHomepageEventName
} from "../store/selectors";

export const useDerbyBanner = () => {
  const navigate = useNavigate();
  const todayDate = useSelector(getTodayDate);
  const derbyTitle = useSelector(getHomepageEventName);
  const derbyBannerCfg = useSelector(getHomepageDerbyBanner);
  const derbyTrackAbbr = useSelector(getHomepageEventTrackAbbr);
  const derbyRace = useSelector(getDerbyRace);
  const derbyEventStatus = useSelector(getHomepageCurrentConfig);
  let derbyRaceDate = useSelector(getEventDate);

  if (derbyEventStatus === DerbyEventStatus.DERBY_DAY) {
    const racePostTime = get(derbyRace, "postTime");
    derbyRaceDate = racePostTime ? new Date(racePostTime) : null;
  }

  const eventType = derbyEventStatus || getEventType(todayDate, derbyRaceDate);
  const bannerCfg = (
    get(derbyBannerCfg, `${eventType}`, []) as Array<HeaderBanner>
  ).find((cfg) => cfg.context.includes(BannerContext.PROGRAM_PAGE));

  const derbyPath = buildRaceUrl(
    derbyTrackAbbr,
    get(derbyRace, "trackName", ""),
    get(derbyRace, "raceNumber", "")
  );

  const onBannerCtaClick = (linkText: string, url: string) => {
    const bannerName = get(derbyTitle, "label", "");
    const linkUrl = url.includes("#derbyRace") ? derbyPath : url;

    mediator.base.dispatch({
      type: "DERBY_HEADER_CLICK",
      payload: {
        linkUrl,
        bannerName,
        linkText
      }
    });
    navigate(linkUrl);
  };

  return {
    derbyRaceDate,
    derbyEventStatus: eventType,
    derbyTrackAbbr,
    bannerCfg,
    onBannerCtaClick
  };
};

export default useDerbyBanner;
